import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { Sparkles, Send, Loader2 } from "lucide-react";

export default function AIAssistant({ open, onClose }) {
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Olá! Sou o Copiloto de Vendas da ATP. Pergunte sobre resumos de clientes, sugestões de follow-up, abordagens comerciais. Cole dados relevantes na sua pergunta para eu analisar." },
  ]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const sessionId = "sales-" + (JSON.parse(localStorage.getItem("atp_user") || "{}")?.id || "anon");

  const send = async () => {
    if (!text.trim() || loading) return;
    const q = text.trim();
    setMessages((m) => [...m, { role: "user", text: q }]);
    setText("");
    setLoading(true);
    try {
      const { data } = await api.post("/ai/sales", { session_id: sessionId, message: q });
      setMessages((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { role: "assistant", text: "Erro ao consultar IA. Tente novamente." }]);
    } finally { setLoading(false); }
  };

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="bg-[#0B0F17] border-l border-[#1E293B] text-slate-100 w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 text-slate-100">
            <Sparkles size={18} className="text-[#0CDBF2]" /> Copiloto de Vendas
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto py-4 space-y-3 pr-1">
          {messages.map((m, i) => (
            <div key={i} data-testid={`ai-msg-${m.role}-${i}`}
              className={`rounded-lg p-3 text-sm whitespace-pre-wrap ${m.role === "user" ? "bg-[#0CDBF2]/10 border border-[#0CDBF2]/30 ml-8" : "bg-[#111622] border border-[#1E293B] mr-8"}`}>
              {m.text}
            </div>
          ))}
          {loading && <div className="text-xs text-slate-500 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Pensando...</div>}
        </div>
        <div className="flex gap-2 pt-3 border-t border-[#1E293B]">
          <Input value={text} onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && send()}
            placeholder="Faça uma pergunta..."
            className="bg-[#07090E] border-[#1E293B] text-slate-100" data-testid="ai-input" />
          <Button onClick={send} disabled={loading} className="bg-[#0CDBF2] hover:bg-[#0ABED4] text-[#07090E]" data-testid="ai-send">
            <Send size={16} />
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
